export var STATE_NAME_BY_SCREEN_NAME_MAP = {
    'small-mobile': 'isSmallMobile',
    mobile: 'isMobile',
    tablet: 'isTablet',
    desktop: 'isDesktop',
    'desktop-xl': 'isDesktopXL',
    'except-desktop': 'isExceptDesktop',
    'except-mobile': 'isExceptMobile',
};
